import { render, staticRenderFns } from "./FornecedorPadraoCotacao.vue?vue&type=template&id=71467a0e"
import script from "./FornecedorPadraoCotacao.vue?vue&type=script&lang=js"
export * from "./FornecedorPadraoCotacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports